import { orchestrator } from 'satcheljs';
import { contactSupport } from 'owa-premium-support-option/lib/actions/contactSupport';
import { toggleCharm } from 'owa-header-store';
export default orchestrator(contactSupport, function () {
    toggleCharm(2 /* HelpCharm */);
});
//# sourceMappingURL=showHelpPane.js.map